/* global L */
/* eslint no-undef: "error" */
import _ from 'lodash'

export default {
  state: {
    isMobile: true,
    modal: true,
    map: false,
    isEmbed: false
  },
  iconOptions (options) {
    let defaults = {
      options: {
        iconSize: [32, 37],
        iconAnchor: [16, 35]
      }
    }
    let DefIcon = L.Icon.extend(_.merge(defaults, options))
    return new DefIcon()
  },
  cache: {
    render: '',
    activate: true,
    categories: [],
    maps: [],
    mapsChild: [],
    category: [],
    category_infos: [],
    map: [],
    mapUrl: [],
    places: [],
    search: {},
    markersGroup: {}
  }
}



// WEBPACK FOOTER //
// ./src/store/store.js